import { useState } from "react";
import "./styling/itsmefrog.css";

const pondLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/lindzhang/", image: "lily-linkedin" },
  { label: "GitHub", href: "https://github.com/lindsayzhng", image: "lily-github" },
  { label: "Library (currently music by Pinegrove)", href: "https://pinegrove.bandcamp.com/album/elsewhere-3", image: "lily-library" },
  { label: "About me", href: "#about", image: "lily-about" },
];

function ItsMeFrog({ onAboutClick, aboutRevealed = false }) {
  const [pinned, setPinned] = useState(false);
  const [hovered, setHovered] = useState(false);

  function toggleReveal() {
    setPinned(value => !value);
    setHovered(false);
  }

  return (
    <div className="pond-wrap">
      <div className="pond" data-revealed={pinned || hovered} onPointerLeave={() => setHovered(false)}>
        <nav className="pond-links" id="lilypad-links" aria-label="Links">
          {pondLinks.map(({ label, href, image }) => (
            <a className={`lily-link ${image}`} key={image} href={href} {...(href === "#about" ? { onClick: onAboutClick, "aria-controls": "about", "aria-expanded": aboutRevealed } : { target: "_blank", rel: "noopener noreferrer" })}>
              <span className="lily-art" aria-hidden="true">
                <img className="lily-plain" src={`/images/${image}.webp`} width="360" height="360" decoding="async" alt="" />
                <img className="lily-revealed" src={`/images/${image}-revealed.webp`} width="360" height="360" decoding="async" alt="" />
              </span>
              <span className="sr-only">{label}{href.startsWith("https:") ? " (opens in a new tab)" : ""}</span>
            </a>
          ))}
        </nav>
        <div className="frog-home">
          <button
            className="frog-button"
            type="button"
            aria-label="Reveal the lilypad links"
            aria-controls="lilypad-links"
            aria-pressed={pinned}
            onPointerEnter={event => { if (event.pointerType !== "touch") setHovered(true); }}
            onClick={toggleReveal}
          >
            <span className="frog-art" aria-hidden="true">
              <img className="frog-resting" src="/images/frog-small.webp" srcSet="/images/frog-small.webp 320w, /images/frog.webp 640w" sizes="(max-width: 600px) 180px, 270px" width="640" height="634" decoding="async" fetchpriority="high" alt="" />
              <img className="frog-happy" src="/images/frog-happy-small.webp" srcSet="/images/frog-happy-small.webp 320w, /images/frog-happy.webp 640w" sizes="(max-width: 600px) 180px, 270px" width="640" height="634" decoding="async" alt="" />
            </span>
          </button>
          <span className="sr-only" role="status">{pinned ? "Lilypad labels revealed. Press the frog again to hide them." : ""}</span>
        </div>
      </div>
    </div>
  );
}

export default ItsMeFrog;
